export default "::ng-deep .center>.dx-overlay-content{top:50% !important;left:50% !important;transform:translate(-50%, -50%) !important;position:fixed}";